export default __webpack_public_path__ + "static/media/sell_composed.4eb47122.png";